import React, { useState } from "react";
import CompanyBasedBillableListing from "@/modules/reports/billables/status/company-listing";
import { StatsSection } from "@/modules/reports/billables/status/components/stats-section";
import ContractedBillablesFilters from "@/modules/reports/billables/status/contracted/filters";
import { startDateForBillables, statusWiseBillingDateFilters } from "@/modules/reports/billables/status/constant";
import CommonTable from "components/list/table";
import { getChildData, getChildColumns, getBillableFiltersFromCompanyFilters } from "@/modules/reports/billables/status/child-table-config";

const ContractedBillables = () => {
  const [filters, setFilters] = useState({
    contacts: {
      projects: {
        jobs: {
          billables: {
            ...statusWiseBillingDateFilters,
            status: {
              _eq: "contracted"
            }
          }
        }
      }
    }
  });

  return (
    <div>
      <CompanyBasedBillableListing
        title="Contracted Billables"
        status="contracted"
        onFiltersChange={setFilters}
        filters={ContractedBillablesFilters}

        sortOrder="asc"
        sortBy="contacts.projects.jobs.billables.billing_date"
        enableAccordion={true}
        renderExpandedRow={(row) => (
          <div className="border rounded-md overflow-hidden bg-background">
            <CommonTable
              data={getChildData(row, "contracted")}
              columns={getChildColumns("contracted")}
              showHeader={true}
            />
          </div>
        )}
        renderContent={() => (
          <StatsSection status="contracted" filters={getBillableFiltersFromCompanyFilters(filters)} />
        )}
        statusWiseFilters={{
          contacts: {
            projects: {
              jobs: {
                billables: {
                  ...statusWiseBillingDateFilters,
                  status: {
                    _eq: "contracted"
                  }
                }
              }
            }
          },
        }}
        statusWiseDateFilters={statusWiseBillingDateFilters}
      />
    </div>
  );
};

export default ContractedBillables;
